import React, { useState } from "react";
import "./RegisterAccountPage.css";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/images/pnmb-logo.png";
import lawImage from "../../../assets/images/law-image2.jpg";
import AccountRegistration from "./AccountRegistration";
import ContactDetails from "./ContactDetails";
import LoginDetails from "./LoginDetails";
import api from "../../../services/baseUrl";

const RegisterAccountPage = () => {
  const [step, setStep] = useState(1);
  const [passwordNotMatch, setPasswordNotMatch] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    packageID: 1,
    categoryId: 1,
    email: "",
    phoneNum: "",
    companyName: "",
    address1: "",
    countryId: 130,
    username: "",
    password: "",
    confirmPassword: "",
    industryId: 1,
    govAgencyId: 1,
  });

  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  const submitForm = async () => {
    setPasswordNotMatch(false);
    try {
      const response = await api.post("/user/register", formData);

      if (response.data === "Registration successful.") {
        alert("User registered successfully");
        navigate("/payment", { state: formData });
      }
    } catch (error) {}
  };
  const navigate = useNavigate();
  return (
    <div className="register1-container">
      <div className="register1-image-container">
        <img
          src={logo}
          alt=""
          className="register1-logo"
          onClick={() => navigate("/")}
        />
        <h1 className="register1-lawnet-text" onClick={() => navigate("/")}>
          Lawnet
        </h1>
        <img src={lawImage} className="register1-image" alt="" />
      </div>
      <div className="register1-create-container">
        <div className="register1-create">
          <div>
            {step === 1 && (
              <AccountRegistration
                formData={formData}
                setFormData={setFormData}
                nextStep={nextStep}
              />
            )}
            {step === 2 && (
              <ContactDetails
                formData={formData}
                setFormData={setFormData}
                prevStep={prevStep}
                nextStep={nextStep}
              />
            )}
            {step === 3 && (
              <LoginDetails
                formData={formData}
                setFormData={setFormData}
                prevStep={prevStep}
                submitForm={submitForm}
                passwordNotMatch={passwordNotMatch}
              />
            )}
          </div>
          <p className="register1-have-account">
            Already have an account?
            <Link to="/login">Login here</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterAccountPage;
